import { getNode } from '@space-cow-media/wp-components'
import { GetServerSidePropsContext } from 'next'

import ArticlePage from '@/components/Wordpress/ArticlePage/ArticlePage'
import { ARTICLES_CACHE_CONTROL } from '@/utils/constants'

export const getServerSideProps = async ({ params, res }: GetServerSidePropsContext) => {
  const slug = params!.slug as string
  const post = await getNode(slug)
  if (!post) return { notFound: true }

  res.setHeader('Cache-Control', ARTICLES_CACHE_CONTROL)

  return {
    props: { enableAdhesion: true, post },
  }
}

export default ArticlePage
